import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { SHIFT_DISCOVERY_WORKPLACE_CLOCK_IN_GUIDE_FULL_PATH } from "../../ShiftDiscovery/paths";
import { useWorkplaceGuide } from "../useWorkplaceGuide";

interface WorkplaceClockInGuideButtonProps {
  workplaceId: string;
  buttonSize?: "medium" | "large";
}

export function WorkplaceClockInGuideButton({
  workplaceId,
  buttonSize = "medium",
}: WorkplaceClockInGuideButtonProps) {
  const { data: clockInGuide } = useWorkplaceGuide({ workplaceId, category: "clock_in" });
  const history = useHistory();

  if (!isDefined(clockInGuide)) {
    return null;
  }

  return (
    <Button
      fullWidth
      variant="outlined"
      size={buttonSize}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.WORKPLACE_CLOCK_IN_GUIDE_OPENED, { workplaceId });
        history.push(
          generatePath(SHIFT_DISCOVERY_WORKPLACE_CLOCK_IN_GUIDE_FULL_PATH, {
            workplaceId,
          })
        );
      }}
    >
      View directions to timeclock
    </Button>
  );
}
